import { render } from "./VoluntaryExam.vue?vue&type=template&id=621b2a5a"
import script from "./VoluntaryExam.vue?vue&type=script&lang=ts"
export * from "./VoluntaryExam.vue?vue&type=script&lang=ts"

import "./VoluntaryExam.vue?vue&type=style&index=0&id=621b2a5a&lang=css"
script.render = render

export default script